import DefaultPaginationNew from "./DefaultPaginationNew";
export default DefaultPaginationNew